export default __webpack_public_path__ + "static/media/stay_connected.a459e750.jpg";